function CheckSvgIcon({ className = "", size = 25 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 12.8 9.89">
      <g>
        <polygon
          className={className}
          points="10.67 0 7.85 2.82 5.73 4.95 4.94 5.74 2.03 2.83 0 4.86 2.91 7.77 2.9 7.77 5.03 9.89 5.03 9.89 7.06 7.86 7.85 7.07 9.97 4.95 12.79 2.12 10.67 0"
        />
      </g>
    </svg>
  );
}

export default CheckSvgIcon;
